import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-ipd',
  templateUrl: './ipd.component.html',
  styleUrls: []
})
export class IpdComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/ipd.component.ts